import { Component, Input } from "@angular/core";

import { User } from "../../../interfaces/user";
import {
  SubscriptionService,
  Address,
} from "../../../services/subscription/subscription.service";

@Component({
  selector: "app-subscription-license",
  templateUrl: "./subscription-license.component.html",
  styleUrls: ["./subscription-license.component.scss"],
})
export class SubscriptionLicenseComponent {
  @Input() user: User;
  @Input() address: Address;

  isNavigating = false;

  constructor(private readonly SubscriptionService: SubscriptionService) {}

  /**
   * Is `true` when all fields of the user's billing address are valid.
   */
  get hasValidAddress() {
    const { line1, postalCode, city, state, country } = this.address;
    return !!(line1 && postalCode && city && state && country);
  }

  /**
   * Redirects to the Stripe customer portal.
   */
  async goToCustomerPortal() {
    this.isNavigating = true;
    window.location.href = await this.SubscriptionService.getCustomerPortalUrl();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/subscription/subscription-license/subscription-license.component.ts